module.exports = __webpack_public_path__ + "static/media/buzhou.eed9f973.png";


//////////////////
// WEBPACK FOOTER
// ./src/invitation/index/image/buzhou.png
// module id = 938
// module chunks = 0